const SHARE_TYPES = {
  TRANSACTION_STORY: 'transaction-story',
  STORY: 'story',
};
export default {
  SHARE_TYPES,
};
